import React from 'react';
import { useRecoilValue } from 'recoil';
import * as AppState from '../../../../AppState';
import FilterDropdown from '../../../Shared/FilterDropdown/FilterDropdown';
import PriceRange from '../PriceRange/PriceRange';
import BedsAndBaths from '../BedsAndBaths/BedsAndBaths';
import SortPropertyCardsDropdown from '../SortPropertyCards/SortPropertyCardsDropdown';
import useResetAllFilters from '../../../Shared/ResetAllFilters';

import './AllFilters.scss';
import PropertyType from '../HomeType/HomeType';
import SquareFootageRange from '../SquareFootageRange/SquareFootageRange';
import PropertyDetailsFilter from '../PropertyDetailsFilter/PropertyDetailsFilter';
import OpenHouseButton from '../OpenHouse/OpenHouseButton';
import classNames from 'classnames';

const AllFilters = (props: {
	hideNavButtons: boolean,
	gsIsMobile: boolean,
}) => {
	const gsIsMobile = useRecoilValue(AppState.gsIsMobile);

	const filterCount = useRecoilValue(AppState.gsFilterCount);

	const showHiddenNavButtons = props.gsIsMobile || props.hideNavButtons;
	const showPriceRangeButton = props.gsIsMobile;

	const [resetAllFilters] = useResetAllFilters();

	return (
		<FilterDropdown
			id="homesearchAllFiltersDropdown"
			className={classNames("homesearch-filters__cc-btn--all-filters cc-btn--navbar text-center w-100", gsIsMobile && 'h-100')}
			wrapperClass="homesearch-filters__cc-btn-wrapper--all-filters"
			label={
				<React.Fragment>
					<i className="far fa-sliders-v me-2" />
					{!gsIsMobile && ('More ')}
					Filters
				</React.Fragment>
			}
			active={filterCount !== 0}
			resetLabel='Reset all filters'
			onResetClick={React.useCallback(
				() => {
					resetAllFilters();
				}, [resetAllFilters])}
			customIcon={filterCount !== 0 && (<span className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center small fw-bold lh-1 ms-2" style={{ width: '1.25rem', height: '1.25rem' }}>{filterCount}</span>)}
			options={
				<div className="homesearch-filters__all-filters-content w-100 mb-3">
					{showHiddenNavButtons &&
						<div className='all-filters__bottom-border py-3 d-flex justify-content-between'>
							<span className="mx-1 w-50"><SortPropertyCardsDropdown id='homesearchPropertyListSortAllFilters' buttonClass='w-100'  fullWidth/></span>
              <OpenHouseButton className='mx-1 w-50' buttonClass='w-100'/>
						</div>
					}

					{showPriceRangeButton &&
						<div className='all-filters__bottom-border pt-4 pb-3'>
							<PriceRange />
						</div>
					}

					{showHiddenNavButtons &&
						<div className='all-filters__bottom-border py-4'>
							<BedsAndBaths />
						</div>
					}
					<div className='all-filters__bottom-border py-4'>
						<PropertyType />
					</div>
					<div className='all-filters__bottom-border py-4'>
						<SquareFootageRange />
					</div>
					<div className='all-filters__bottom-border py-4'>
						<PropertyDetailsFilter />
					</div>
				</div >
			}
		/>
	);
};

export default AllFilters;
